<template>
	<view class="navbutton">
		<view class="menu" @click="menuClick()">
			<text>{{menu}}</text>
			<view v-if="childmenusLength>0">
				<view class="icon on" v-if="ison">
                    <img src="img/arrow-down.png"/>
				</view>
				<view class="icon off" v-else>
					<img  src="img/arrow-up.png"/>
				</view>
			</view>
		</view>
		<view class="child-menu-group"  v-if="ison">
			<view class="child-menu" v-for="(item,index) in childmenus" :key="index" :class="{active:activeIndex==index}" @click="childmenuClick(index)">
				<span>{{item.name}}</span>
			</view>
			
		</view>
	</view>
</template>

<script>
import { throwStatement } from '@babel/types';

	export default {
		name:"navbutton",
		props:{
			menu:String,
			childmenus:{
				type:Array,
			},
			menuIndex:Number
		},
		data() {
			return {
				ison : true,
				activeIndex:0,
				childmenusLength:0,
			};
		},
		methods:{
			menuClick(){
				this.ison = !this.ison;
			},
			childmenuClick(index){
				this.activeIndex = index;
				this.$emit("childMenuChange",index)
			}
		},
		created() {
			if(this.childmenus==undefined){
				this.childmenusLength  = 0;
			}else{
				this.childmenusLength = this.childmenus.length;
			}

			if(this.menuIndex == undefined){
				this.activeIndex =0;
			}else{
				this.activeIndex = this.menuIndex ;
			}
		}
	}
</script>

<style lang="scss" scoped>
	
	.navbutton{
		display: flex;
		flex-direction: column;
		.menu{
			width: 286px;
			height: 48px;
			color: white;
			background-color: #1DB5CD;
			display: flex;
			align-items: center;
			text{
				text-align: center;
				line-height: 48px;
				flex: 1;
				font-weight: 600;
			}
			.icon{
				margin-right: 10px;
				width: 16px;
				height: 16px;
				img{
					width: 16px;
					height: 16px;
				}
			}
		}
		.menu:hover{
			cursor: pointer;
		}
		.child-menu{
			width: 286px;
			height: 48px;
			border-top: 1px #dcdcdc solid;
			border-bottom: 1px white solid;
			text-align: center;
			background-color: #ECECEC;
			display: flex;
			font-size: 1.6ch;
			span{
				
				height: 100%;
				width: 100%;
				padding: 0 14px;
				padding-right: 40px;

				display:-webkit-box;
				display:-moz-box;
				display:-ms-flexbox;
				display: -webkit-flex;
				display:flex; 
				-webkit-align-items:center;
				align-items:center;
				-webkit-justify-content: center;
				justify-content: center;

			}
		}
		.child-menu:hover{
			background-color: #ddd;
			font-weight: 600;
			cursor: pointer;
		}
		.active{
			background-color: #ddd;
		
		}
	}
</style>